import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(marketing)/westminstertower/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/WestminsterTowerFooter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/WestminsterTowerHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components-launch/WestminsterTower/WestminsterTowerRegistration/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ComingSoon/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonTransition/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CommonWrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DisclaimerToggleProvider"] */ "/app/src/hooks/useDisclaimerToggle.tsx");
